import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import Table from "@/common/components/Table";
import TextField from "@/common/components/TextField";
import useDebounce from "@/common/hooks/useDebounce";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { Mapper } from "@/common/services/mapper";
import { clientUserBranchesAccessesTableColumns } from "@/features/companyBranches/constants/clientUserBranchAccessesTableColumns.constant";
import { useClientUserBranchAccesses } from "@/features/companyBranches/hooks/useClientUserBranchAccesses";
import { ClientUserBranchAccessesTransformer } from "@/features/companyBranches/services/clientUserBranchAccessesTransformer";
import { SearchIcon } from "lucide-react";
import { useParams } from "react-router-dom";

const UserBranchesAccesses = () => {
  const { id } = useParams();

  const { filterParams, setFilterParams } = useFilterParams();

  const [search, setSearch] = useDebounce('');

  const {
    data: clientUserBranchAccesses,
    meta,
    isPending: clientUserBranchAccessesIsPending,
    error: clientUserBranchAccessesError = {} as any,
    refetch: clientUserBranchAccessesRefetch,
  } = useClientUserBranchAccesses({
    filters: {
      clientUserId: id,
      search,
      page: Number(filterParams.userBranchAccessesPage) || 1,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: ClientUserBranchAccessesTransformer.tableTransformer(),
    }),
  });

  return (
    <ErrorMessageWrapper
      statusCode={clientUserBranchAccessesError?.status}
      refetchFunction={clientUserBranchAccessesRefetch}
      className="h-96"
    >
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-4">
          <TextField
            LeftIcon={<SearchIcon />}
            placeholder="Busque pelo nome da filial"
            className="rounded-sm w-full"
            onChange={(e) => {
              setSearch((e.target as HTMLInputElement).value);
              setFilterParams((prev) => ({ ...prev, userBranchAccessesSearch: (e.target as HTMLInputElement).value }));
            }}
            value={filterParams.userBranchAccessesSearch}
          />
        </div>

        <Table
          className="max-h-[calc(100vh-270px)]"
          columns={clientUserBranchesAccessesTableColumns}
          rows={clientUserBranchAccesses}
          totalCount={meta.total}
          totalPages={meta.total_pages}
          isLoadingData={clientUserBranchAccessesIsPending}
          rowEmptyValue="--"
          page={Number(filterParams.userBranchAccessesPage) || 1}
          setPage={(userBranchAccessesPage) => setFilterParams((prev) => ({ ...prev, userBranchAccessesPage }))}
          hasPagination
        />
      </div>
    </ErrorMessageWrapper>
  );
}

export default UserBranchesAccesses;
